export default __webpack_public_path__ + "static/media/img-05-mini.0fca23b3.png";